export const getHongKongDate = () => {
    const d = new Date();
    const utc = d.getTime() + d.getTimezoneOffset() * 60000;
    const hkDate = new Date(utc + 3600000 * 8); // HK +8 timezone
    return hkDate;
};
